module.exports = __webpack_public_path__ + "img/Checkbox-Off_16px_2_Icon-light.45737c11.svg";